import React, { Fragment } from "react"

import {
  AccordionComponent as Accordion,
  Summary,
  Details,
  Text,
} from "components/ui/Accordion"

const Content = () => {
  return (
    <Fragment>
      <Accordion>
        <Summary>Почему мой долг у PlusPlus?</Summary>
        <Details>
          <Text>
            PlusPlus покупает долговые портфели, состоящие из регулярно
            неоплаченных счетов, у банков, компаний мобильной связи и прочих
            предприятий с обширной базой клиентов. Компании в основном не хотят
            самостоятельно заниматься клиентами, которые своевременно не
            выполняют свои обязанности, и эти требования продаются предприятиям,
            занимающимся истребованием долгов. Если ваши невыполненные
            обязанности дошли до PlusPlus Capital, то это произошло именно
            вышеописанным образом и по вышеприведенным причинам. PlusPlus
            является новым юридическим собственником требования, и таким образом
            является также дальнейшим партнером при погашении задолженности.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Что делать?</Summary>
        <Details>
          <Text>
            В течение некоторого времени мы имели дело с десятками тысяч
            подобных случаев, и мы понимаем, почему не всегда возможно выполнить
            свои финансовые обязанности. По этой причине мы предлагаем помощь в
            составлении разумного и посильного плана выплаты для погашения
            задолженности, учитывая конкретные доходы и прочие обстоятельства.
            Наши профессиональные работники ориентированы на быстрое и
            эффективное разрешение дел, в связи с чем просим вас звонить по
            номеру, приведенному в письме, полученном вами от PlusPlus, или
            обращайтесь к нам по электронной почте, отметив приведенный в письме
            номер ссылки. Чем скорее вы договоритесь о решении долгового
            вопроса, тем дешевле и легче для всех сторон это получится.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>К кому следует обращаться по вопросу о долге?</Summary>
        <Details>
          <Text>
            Если фирма PlusPlus связалась с вами, то это означает, что ваш
            изначальный кредитор в течение определенного времени не дождался ни
            положительной развязки долговых отношений с вами, ни компромисса, и
            он продал это требование. Таким образом, собственником требования и
            партнером в решении вопроса в отношении требования является
            PlusPlus, и больше нет оснований для общения по данному вопросу с
            изначальным кредитором. Если вы обратитесь к своему изначальному
            кредитору, то вас направят к PlusPlus.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Почему мне раньше не сообщали о долге?</Summary>
        <Details>
          <Text>
            Если вы подписали в банке договор займа или заключили договор услуг
            – например, с оператором мобильной связи, то обычно такой документ
            позволяет продать вытекающие из договора задолженности вместе со
            всеми следующими из договора правами таким предприятиям как
            PlusPlus. Банки, операторы мобильной связи и прочие предлагающие
            услуги фирмы пытаются на протяжении некоторого времени добиться
            погашения задолженности самостоятельно, в большинстве случаев
            связываясь со своими клиентами по этому вопросу несколько раз.
            PlusPlus также незамедлительно оповещает клиента письмом о покупке
            требования. Такие письма отправляются по последнему известному
            адресу клиента, и если – например, при переезде клиента – его адрес
            не был обновлен в базе данных клиентов, то может случиться так, что
            информация о задолженности и ее отчуждении не дойдет до клиента.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Что произойдет с моей информацией о кредитах?</Summary>
        <Details>
          <Text>
            Процедуры управления кредитами на предприятиях предусматривают, что,
            начиная с определенной давности и суммы долга о задолженности
            клиента сообщается в регистр нарушения платежей Krediidiinfo.
            Подобная информация общественно доступна и может стать препятствием
            для получения займов, лизингов, рассрочки платежа и прочих кредитных
            продуктов в дальнейшем, а также препятствием для устройства на новое
            рабочее место или заключения договора аренды.
          </Text>
        </Details>
      </Accordion>
    </Fragment>
  )
}

export default Content
